import React, { useState } from "react";

/* A person's photo, or their initials on a colour picked from their name —
   so the same person is always the same colour, everywhere, without anyone
   having to choose one. Falls back to initials if the photo fails to load
   (a deleted file, a flaky connection) rather than showing a broken image. */
const TONES = [
  "bg-amber-100 text-amber-700", "bg-emerald-100 text-emerald-700", "bg-sky-100 text-sky-700",
  "bg-violet-100 text-violet-700", "bg-rose-100 text-rose-700", "bg-teal-100 text-teal-700",
];

export function initials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

function toneFor(name = "") {
  let h = 0;
  for (const c of String(name)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return TONES[h % TONES.length];
}

export default function Avatar({ name, src, size = 36, className = "" }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.38)) };
  if (src && !failed) {
    return (
      <img src={src} alt={name || "Profile photo"} style={style} onError={() => setFailed(true)}
        className={`rounded-full object-cover shrink-0 bg-gray-100 ${className}`} />
    );
  }
  return (
    <span style={style} aria-label={name || "Profile"}
      className={`rounded-full shrink-0 inline-flex items-center justify-center font-semibold ${toneFor(name)} ${className}`}>
      {initials(name)}
    </span>
  );
}

export const ROLE_LABEL = {
  owner: "Owner",
  manager: "Manager",
  frontdesk: "Front desk",
  pos_staff: "POS staff",
  accountant: "Accountant",
};
